export const getDateTimeString = () => {
  return new Date().toLocaleString();
}

export const genMinMaxAvgNote = (parentState) => {
  let g = parentState.grid;
  let gS = {
    "num": 0,
    "ming": 9999,
    "maxg": -1,
    "sumg": 0
  }
  g.forEach(item => {
    var grade = Number(item[item.length - 1].value);
    if (grade > gS.maxg) {
      gS.maxg = grade;
    }
    if (grade < gS.ming) {
      gS.ming = grade;
    }
    gS.sumg += grade;
    gS.num++;
  });
  if (gS.ming === 9999) {
    // return "Keine Daten vorhanden";
    // return ["Keine", "Daten", "vorhanden"];
    return ["", "", ""];
  } else {
    // return gS.ming + " / " + gS.maxg + " / " + Math.round(((gS.sumg / gS.num) + Number.EPSILON) * 100) / 100;;
    return [gS.ming, gS.maxg, Math.round(((gS.sumg / gS.num) + Number.EPSILON) * 100) / 100];
  }
}

export const genMinMaxAvgPunkte = (parentState) => {
  let g = parentState.grid;
  let pS = {
    "num": 0,
    "minsum": 9999,
    "maxsum": -1,
    "sumsum": 0
  }
  g.forEach(item => {
    var sum = 0;
    for (var i = 2; i < item.length - 2; i++) {
      sum += Number(item[i].value);
    }
    if (sum > pS.maxsum) {
      pS.maxsum = sum;
    }
    if (sum < pS.minsum) {
      pS.minsum = sum;
    }
    pS.sumsum += sum;
    pS.num++;
  });
  if (pS.minsum === 9999) {
    // return "Keine Daten vorhanden";
    return ["", "", ""];
  } else {
    // return pS.minsum + " / " + pS.maxsum + " / " + Math.round(((pS.sumsum / pS.num) + Number.EPSILON) * 100) / 100;
    return [pS.minsum, pS.maxsum, Math.round(((pS.sumsum / pS.num) + Number.EPSILON) * 100) / 100];
  }
}